
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../grpc"

export interface AddDeviceRequest {
    deviceList: Array<NewDevice> /* 新设备列表 */
}

export interface NewDevice {
    type: DeviceType /* 设备类型 */
    serialNumber?: string /* 设备序列号 */
    productionBatch?: string /* 生产批号 */
}

export interface OperateRequest {
    serialNumberList: Array<string>
    toOrganizationId?: number /* 与「fromOrganizationId」是一对儿，表示的是设备的流向到哪个组织，fromOrganizationId后台自己能得到 */
}

export interface GetDeviceResponse {
    device: Device
}

export interface GetDeviceRequest {
    serialNumber?: string /* 设备序列号 */
}

export interface GetDeviceStateBySerialNumberResponse {
    state: DeviceState /* 设备状态 */
}

export interface GetDeviceStateBySerialNumberRequest {
    serialNumber?: string /* 设备序列号 */
}

export interface ListDeviceResponse {
    deviceList: Array<Device>
}

export interface PageListDeviceResponse {
    deviceList: Array<Device>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    number: number
    numberOfElements: number
    size: number
    deviceOnlineCount: number
    deviceOfflineCount: number
}

export interface Device {
    type: DeviceType /* 设备类型 */
    serialNumber?: string /* 设备序列号 */
    state: DeviceState /* 设备状态 */
    productionBatch?: string /* 生产批次 */
    inOrganizationId?: number /* 在哪个组织手里 */
    records: Array<DeviceRecord> /* 进销存记录 */
}

export interface DeviceRecord {
    fromOrganizationId?: number /* 从哪个组织ID */
    toOrganizationId?: number /* 到了哪个组织ID */
    operatingTimestamp?: number /* 操作时间 */
    operateAccountId?: number /* 操作人accountID */
}

export interface ListDeviceRequest {
    organizationId?: number
    typeList: Array<DeviceType> /* 设备类型 */
    stateList: Array<DeviceState> /* 设备状态 */
}

export interface PageListDeviceRequest {
    organizationId?: number
    typeList: Array<DeviceType> /* 设备类型 */
    stateList: Array<DeviceState> /* 设备状态 */
    pageNum: number
    pageSize: number
}

export interface UpdateStateRequest {
    serialNumberList: Array<string> /* 设备序列号列表 */
    state: DeviceState
}

export interface OperateResult {
    done: boolean
}

export enum DeviceState {
    ONLINE = 0,
    OFFLINE = 1,
}

export enum DeviceType {
    DEVICE_TYPE_UNKNOWN = 0,
    PRESSURE_PLATE = 1, /* 压力板 */
    FOOT_SCANNER = 2, /* 扫脚仪 */
}

export class DeviceService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 增加设备 */
    async addDevice(request: AddDeviceRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/base.device.DeviceService/AddDevice"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 设备出入库操作（需要登录，因为要记录操作人） */
    async operate(request: OperateRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/base.device.DeviceService/Operate"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 修改设备状态（吊销设备、上线设备） */
    async updateState(request: UpdateStateRequest): Promise<OperateResult> {
        const method = "post"
        const path = "/base.device.DeviceService/UpdateState"
        return await this.call(method, path, request) as OperateResult
    }
    
    /* 分页查看设备列表 */
    async pageListDevice(request: PageListDeviceRequest): Promise<PageListDeviceResponse> {
        const method = "post"
        const path = "/base.device.DeviceService/PageListDevice"
        return await this.call(method, path, request) as PageListDeviceResponse
    }
    
    /* 查看设备列表（未分页） */
    async listDevice(request: ListDeviceRequest): Promise<ListDeviceResponse> {
        const method = "post"
        const path = "/base.device.DeviceService/ListDevice"
        return await this.call(method, path, request) as ListDeviceResponse
    }
    
    /* 查看设备详情 */
    async getDevice(request: GetDeviceRequest): Promise<GetDeviceResponse> {
        const method = "post"
        const path = "/base.device.DeviceService/GetDevice"
        return await this.call(method, path, request) as GetDeviceResponse
    }
    
    /* 查看某个设备的状态 */
    async getDeviceStateBySerialNumber(request: GetDeviceStateBySerialNumberRequest): Promise<GetDeviceStateBySerialNumberResponse> {
        const method = "post"
        const path = "/base.device.DeviceService/GetDeviceStateBySerialNumber"
        return await this.call(method, path, request) as GetDeviceStateBySerialNumberResponse
    }
    
}
